import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/app-context';
import swal from 'sweetalert';
import API from '../helper/API';
import { paymentInit, generateMyDietPlan, getActivateHooksWeb, paymentInitSubscription } from '../helper/mobile';
import { PlanName, PlanType } from '../constants';
import { healthConditionsDuplicate } from '../context/staticData';

export const useDiet = () => {
  const [state, dispatch] = useContext(AppContext);
  let navigate = useNavigate();
  const [timerDisplay, setTimerDisplay] = useState(false);

  console.log("state of dietplan", state);
  const makeDietPayment = (plan, planType, paymentType) => {

    const assessmentUserArr = {
      "userId": state.user.id,
      "groupId": state.user.id,
      "appVersion": state.user.appVersion,
      "osType": state.user.osType,
      "assessmentDetails": {
        planType: (plan !== PlanName.ELITE_PLAN && plan !== PlanName.YEARLY_ELITE_PLAN) ? planType : null
      }
    }
    
    API.post(`/user/dietplan/pre-filled`, assessmentUserArr).then(response => {
      if(response?.status === 201 && response?.data) {
        dispatch({
          type: "USER_DETAILS",
          payload: {dietPlanId: response.data.dietPlanId}
        });
        let requestData = {
          "dietPlanId": response.data.dietPlanId,
          "userId": state.user.id,
          "groupId": state.user.id,
          "appVersion":state.user.appVersion,
          "osType":state.user.osType,
          "dietPlanType":plan
        }
        if(paymentType === 'upi') {
          requestData = {...requestData, ...{"paymentType": paymentType}}
        }
    
        // if(upgradeData) {
        //   requestData = {...requestData, ...{"upgraded":true}}
        // }
        
        
        if(paymentType === 'upi') {
          API.post(`user/dietplan/add?dietPlanId=one_month_smart_paid_diet_plan&paymentType=upi`).then(response => {
            if(response?.status === 201 && response?.data) {
              window.location.replace(response?.data?.paymentUrl);
              dispatch({
                type: "TIMER_DISPLAY",
                payload: true
              });
                let duration = 20000;
                let count = 0;
                let timerid = setInterval(async () => {
                    
                    // const result = await dietPlan({id: onboardingResponse?.dietPlanId}).unwrap();
                    API.get(`/user/dietplan/?userId=${response?.data?.userId}`).then(response => {
                      if(response?.data && response?.data?.paymentStatus === 'payment_successful'){
                          clearInterval(timerid);
                          const userData = state?.user;
                          const urlData = `/dietPlan?isGoalSet=true&isActivateCode=false&appVersionCode=${userData?.appVersionCode}&appVersion=${userData?.appVersion}&osType=${userData?.osType}&token=${userData?.token}`;
                          navigate(urlData);
                      }else {
                          if(count === 8){
                              clearInterval(timerid);
                              console.log("Payment Fail!!!!!");
                              dispatch({
                                type: "TIMER_DISPLAY",
                                payload: false
                              });
                          }
                      }

                      count++;
                    })
                    
                    
                }, duration);
            }
          }).catch(error => {
            console.log("Error", error);
          })
        }else {
          API.post('/user/dietplan', requestData).then(response => {
            if(response?.status === 201 && response?.data) {
              const {planType, subscriptionId, orderId} = response.data;
              if(planType !== PlanType.SHEETPLAN) {
                paymentInitSubscription(subscriptionId, planType, state.user.appVersion);
              }
              else {
                paymentInit(orderId)
              }
            }
          }).catch(error => {
            console.log("Error", error);
          })
        }
        
        
        // navigate(`/dietPlan/dietPlanAnalyzing/${response.data.dietPlanId}`);
      }
    }).catch(error => {
      console.log("Error", error);
    })

  }



  const updateAssessment = (requestData, dietPlanId) => {
    API.put(`/user/dietplan/assessment/${dietPlanId}`, requestData).then(response => {
      console.log("Response", response);
      if(response?.status === 200 && response?.data) {
        generateMyDietPlan();
        localStorage.setItem('planStartDate', response.data.planStartDate);
        navigate(`/diet/${response.data.dietPlanType}/${response.data.dietPlanId}/assessment/dietPlanAnalyzing`);
      }
    }).catch(error => {
      console.log("Error", error);
    })
  }

  const generateAssessment = (requestData, activatePlan=false) => {
    
    const assessmentUserArr = {
      "userId": state.user.id,
      "groupId": state.user.id,
      "appVersion": state.user.appVersion,
      "osType": state.user.osType,
      "assessmentDetails": requestData
    }

    const assessmentUserArrAsd = { ...requestData }

    if(state?.user?.dietPlanId) {
      assessmentUserArr.dietPlanId = state.user.dietPlanId;
    }
    // const URL = 
    API.put(`/user/dietplan/assessment/${state?.existingDietplan.dietPlanId}?activatePlan=${activatePlan}`, assessmentUserArrAsd).then(response => {
      if(response?.status === 200 && response?.data) {
        dispatch({
          type: "USER_DETAILS",
          payload: {dietPlanId: response.data.dietPlanId}
        });
        let id;
        if(['one_month_smart_diet_plan', 'three_month_smart_paid_diet_plan', 'one_month_smart_paid_diet_plan'].includes(response.data.dietPlanType))
          id = 'ai'
        else
          id = response.data.dietPlanId;

        navigate(`/dietPlan/dietPlanAnalyzing/${id}`);
      }
    }).catch(error => {
      console.log("Error", error);
    })

    // if(state?.user?.isActivateCode === 'true') {
      
    // }else {
    //   API.post(`/user/dietplan/pre-filled`, assessmentUserArr).then(response => {
    //     if(response?.status === 201 && response?.data) {
    //       dispatch({
    //         type: "USER_DETAILS",
    //         payload: {dietPlanId: response.data.dietPlanId}
    //       });
    //       navigate(`/dietPlan/dietPlanAnalyzing/${response.data.dietPlanId}`);
    //     }
    //   }).catch(error => {
    //     console.log("Error", error);
    //   })
    // }
    
    
  }

  const requestCall = (reqData) => {
    if(state?.user?.mobileNumber) {
      API.post('user/dietplan/call-back', {reason: reqData}).then(response => {
        localStorage.setItem("requestCallTime", new Date());
        swal({
          className: "swal-height-width-change",
          title: "Call request submitted",
          text: "Thank you for submitting the request. Our nutritionist will get in touch with you in the next 72hrs.",
          buttons: "Done"
        })
      }).catch(error => {
        console.log("Error", error);
      })
    }else {
      swal({
        className: "swal-height-width-change",
        title: "Mobile number not found",
        text: "To register your call request please update your mobile number in the profile section",
        buttons: "Done"
      })
    }
  }

  const upgradeRequestCall = () => {
    API.post(`/user/dietplan/upgrade-alert?dietPlanId=${state.user.dietPlanId}`).then(response => {
        swal({
          className: "swal-height-width-change",
          title: "Upgrade request submitted",
          text: "Our team has received your upgrade request. We will soon get in touch with you.",
          buttons: "Done"
        })
    }).catch(error => {
      console.log("Error", error);
    })
  }

  const healthConditionsBuild = (fd) => fd.map(obj => healthConditionsDuplicate.find(i => i.heathConditionValue === obj));

  const dietPlanGoogleForm = (formData, dietPlanId) => {
    if(formData.length === 6){
      const formDataBody = {
        "medications": formData.find(obj => obj.name === 'medication').option[0] === 'yes' ? true : false,
        "allergies": formData.find(obj => obj.name === 'allergies').option,
        "healthConditions": healthConditionsBuild(formData.find(obj => obj.name === 'healthConditions').option),
        "healthGoals": formData.find(obj => obj.name === 'healthGoals').option,
        "preferredCuisine": formData.find(obj => obj.name === 'preferredCuisine').option,
        "dietaryPreference": formData.find(obj => obj.name === 'dietaryPreference').option
      }
      API.put(`/user/dietplan/form/${dietPlanId}`, formDataBody).then(response => {
        const url = `/dietPlan?appVersionCode=${state.user.appVersionCode}&appVersion=${state.user.appVersionCode}&osType=${state.user.osType}&token=${state.user.token}`;
        navigate(url);
        getActivateHooksWeb();
      }).catch(error => {
        console.log("Error", error);
      })
    }else {
      swal({
        className: "swal-height-width-change",
        title: "Opps..",
        text: "Something went wrong",
        buttons: "Okay"
      })
    }
    
  } 

  return {
    makeDietPayment,
    updateAssessment,
    generateAssessment,
    requestCall,
    upgradeRequestCall,
    dietPlanGoogleForm
  }
}